// extracted by mini-css-extract-plugin
export default {"page-title":"styles_page-title__YL3u6","skill-search":"styles_skill-search__+1jUx","layout":"styles_layout__xv6Y3","container":"styles_container__c-TZ2"};